import Header from '../utill/Header'
import Footer from '../utill/Footer'
import Sidebar from '../utill/Sidebar'
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Button, Card, Form, Table} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Url from "../utill/Url";
import axios from "axios";
import {useSelector} from "react-redux";
import Pagination from "../utill/Pagination";
import {reissue} from "../utill/UtilComponent";
import {
    Paper,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import dayjs, {Dayjs} from "dayjs";
import Loading from '../utill/Loading';
import {RootState} from "../../redux/store";
import StyledTableCell from "../utill/StyledTableCell"

function DeviceManagement() {

    const url = useContext(Url);
    const navigate = useNavigate();
    const [data, setData] = useState<Device[]>([]);
    const [searchedData, setSearchedData] = useState(["",""]);
    const [startDtm, setStartDtm] = useState("");
    const [endDtm, setEndDtm] = useState("");
    const [totalData, setTotalData] = useState(0)
    const [totalPages, setTotalPages] = useState(0);
    const [usingSerialCnt, setUsingSerialCnt] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [selected, setSelected] = useState("1");
    const [listSelected, setListSelected] = useState("15");
    const [deviceSelected, setDeviceSelected] = useState("0");
    const [deviceType, setDeviceType] = useState<DeviceType[]>([]);
    const [customerCodeSelected, setCustomerCodeSelected] = useState("");
    const [customerCode, setCustomerCode] = useState<CustomerCode[]>([]);
    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [checkedItems, setCheckedItems] = useState<string[]>([]);
    const [startDate, setStartDate] = React.useState<Dayjs>(dayjs().locale('ko'));
    const [endDate, setEndDate] = React.useState<Dayjs>(dayjs().locale('ko'));
    const [textData, setTextData] = useState('');
    const [textCurrentPage, setTextCurrentPage] = useState('');
    const [selectType, setSelectType] = useState("1");
    const user = useSelector((state: RootState) => state.user.value);
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [writeAuthorityYn, setWriteAuthorityYn] = useState(false);
    const [loading, setLoading] = useState(true);

    let userId = user.id;
    let nowCustomerCode = user.customerCode;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-디바이스 관리'
        if (auth.MENUAUTH?.DEV0000?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'device/devicetype', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setDeviceType(response.data.result)
            })
            axios.get(url + 'customercode/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setCustomerCode(response.data.result.data)
                setCustomerCodeSelected(response.data.result.data[0].customerCode)
            })
            setWriteAuthorityYn(auth.MENUAUTH?.DEV0000?.writeAuthorityYn === "1")
        })
    }, []);

    useEffect(() => {
        setLoading(true);
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'device/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    data: searchedData.join(','),
                    type: selectType,
                    page: currentPage,
                    startDtm: startDtm,
                    endDtm: endDtm,
                    listCnt:listSelected
                }
            })
                .then((response) => {
                    setData(response.data.result.data)
                    setTotalData(response.data.result.totalData)
                    setTotalPages(response.data.result.totalPage)
                    setUsingSerialCnt(response.data.result.usingSerialCnt)
                    setLoading(false);
                })
        })
    }, [currentPage, listSelected])

    useEffect(() => {
        setCurrentPage(1);
        setTextCurrentPage('1');
    }, [listSelected]);

    const handleSubmit = async () => {
        let data = ["",""];
        setCurrentPage(1)
        setTextCurrentPage("1")
        setSelectType(selected)
        if (selected === "4") {
            data[0] = deviceSelected;
        } else if (selected === "5") {
            setStartDtm(startDate.format('YYYY-MM-DD 00:00:00'));
            setEndDtm(endDate.format('YYYY-MM-DD 23:59:59'));
        } else if (selected === "2") {  // selected가 2인 경우는 별도로 처리
            data[0] = textData;
        } else if (selected === "3" || selected === "6") {  // selected가 3 또는 6(릴리즈 번호)일 때만 숫자 검증
            const parsedTextData = /[^\d]/.test(textData) ? NaN : parseInt(textData, 10);
            if ((!isNaN(parsedTextData) && parsedTextData > 0) || textData === '') {
                data[0] = textData;
                data[1] = customerCodeSelected;
            } else {
                alert("릴리즈 번호는 숫자여야 합니다.");
                return;
            }
        } else {
            data[0] = textData;
        }
        setSearchedData([...data])
        setLoading(true);
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'device/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    data: data.join(','),
                    type: selected,
                    page: 1,
                    startDtm: startDate.format('YYYY-MM-DD 00:00:00'),
                    endDtm: endDate.format('YYYY-MM-DD 23:59:59'),
                    listCnt:listSelected
                }
            }).then((response) => {
                setData(response.data.result.data);
                setTotalData(response.data.result.totalData);
                setUsingSerialCnt(response.data.result.usingSerialCnt)
                if (response.data.result.totalPage !== 'undefined') {
                    setTotalPages(response.data.result.totalPage);
                } else {
                    setTotalPages(1)
                }
                setLoading(false);
            })
        })
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setTextCurrentPage(page.toString());
        setCheckedItems([]);
    };

    const handleClick = () => {
        navigate('/OrderingSerialNumber');
    };

    const handleCurrentPageText = () => {
        const numericValue = parseInt(textCurrentPage, 10);
        if (!isNaN(numericValue) && numericValue > 0 && numericValue <= totalPages) {
            // 숫자인 경우
            setCurrentPage(numericValue);
        } else if(numericValue >= totalPages){
            alert('총 페이지 보다 높은 수를 입력하실 수 없습니다')
        }else {
            // 숫자가 아닌 경우
            alert("숫자만 입력 가능합니다.");
        }
    };

    const handleChangeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value)
    }

    const handleChangeListSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setListSelected(e.target.value);
    }

    const handleChangeDeviceSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setDeviceSelected(e.target.value)
    }

    const handleChangeCustomerCodeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setCustomerCodeSelected(e.target.value)
    }

    let selectedValueTitle = "";
    let selectedValueContent = "";
    let textState = "active";
    let deviceSelectState = "inactive";
    let calendarSelectState = "inactive";
    let customerSelectState = "inactive";
    let customerCodeSelect = "";

    if (selected === "1") {
        selectedValueTitle = "시리얼번호로";
        selectedValueContent = "시리얼번호를";
    } else if (selected === "2") {
        selectedValueTitle = "설명으로";
        selectedValueContent = "설명을";
    } else if (selected === "3") {
        selectedValueTitle = "릴리즈넘버로"
        selectedValueContent = "릴리즈넘버를";
    } else if (selected === "4") {
        selectedValueTitle = "디바이스타입으로"
        selectedValueContent = "디바이스타입을";
        textState = "inactive"
        deviceSelectState = "active"
    } else if (selected === "5") {
        selectedValueTitle = "생성일로"
        selectedValueContent = "생성일을";
        textState = "inactive"
        calendarSelectState = "active";
    } else if (selected === "6") {
        selectedValueTitle = "고객사코드로"
        selectedValueContent = "고객사코드를";
        customerSelectState = "active";
        customerCodeSelect = "customerCode";
    } 

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = e.code;
        if (key === 'Enter' || key === 'NumpadEnter') {
            e.preventDefault();
            handleSubmit();
        }
    }

    const handleStartDate = (newValue: Dayjs | null) => {
        if (!newValue) return;

        setStartDate(newValue);
    }

    const handleEndDateChange = (newValue: Dayjs | null) => {
        if (!newValue) return;

        if (newValue.isBefore(startDate)) {
            setStartDate((newValue.subtract(1, 'day')));
            setEndDate(newValue);
        } else {
            setEndDate(newValue);
        }
    };

    function customerFormat(code: string) {
        let formattedCode = code;
        if (formattedCode) {
            customerCode.forEach(customer => {
                const regex = new RegExp(customer.customerCode, 'gi');
                formattedCode = formattedCode.replace(regex, customer.customerName);
            });
        } else {
            formattedCode = '-'
        }
        return formattedCode;
    }

    useEffect(() => {
        // 전체 선택 체크 여부 판단
        const allChecked = data.length > 0 && checkedItems.length === data.length;
        setIsCheckedAll(allChecked);
    }, [checkedItems, data]);

    const selectAll = (event: any) => {
        const {checked} = event.target;
        setIsCheckedAll(checked);

        if (checked) {
            const allSerialNumbers = data.map((device) => device.serialNumber);
            setCheckedItems(allSerialNumbers);
        } else {
            setCheckedItems([]);
        }
    };
    const handleSingleCheckboxChange = (event: ChangeEvent<HTMLInputElement>, serialNumber: string) => {
        const {checked} = event.target;

        if (checked) {
            setCheckedItems((prevItems) => [...prevItems, serialNumber]);
        } else {
            setCheckedItems((prevItems) =>
                prevItems.filter((item) => item !== serialNumber)
            );
        }
    };

    const handleDeleteUser = async () => {
        if (checkedItems.length === 0) {
            alert('아무것도 고르지 않으셨습니다');
            return;
        }
        try {
            await reissue(userId, url, navigate);
            await deleteDevices(url);
            await fetchData(url);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const deleteDevices = async (url: string) => {
        const Delete = window.confirm(`선택된 시리얼번호를 삭제하시겠습니까?`);
        if (Delete) {
            try {
                const response = await axios.post(
                    url + 'device/delete',
                    {serialList: checkedItems},
                    {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    }
                );
                setCheckedItems(response.data.result)
                handleDeleteResponse(response.data);
            } catch (error) {
                console.error('Error deleting devices:', error);
            }
        } else {
            console.log('삭제 취소');
        }
    };

    const handleDeleteResponse = (data: { result: string | any[]; }) => {
        if (data.result.length === 0) {
            alert('삭제되었습니다');
        } else if (checkedItems.length === data.result.length) {
            alert(`${data.result.toString()}는 사용중인 시리얼번호입니다.`);
        } else {
            alert(`${data.result.toString()}는 사용중인 시리얼번호입니다.\n이외의 데이터는 삭제 되었습니다.`);
        }
    };

    const fetchData = async (url: string) => {
        try {
            axios.get(url + 'device/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    data: searchedData.join(','),
                    type: selectType,
                    page: 1,
                    startDtm: startDtm,
                    endDtm: endDtm,
                    listCnt:listSelected
                }
            })
                .then((response) => {
                    setData(response.data.result.data)
                    setTotalData(response.data.result.totalData)
                    setTotalPages(response.data.result.totalPage)
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    return (
        <div id="wrapper">
            <Sidebar menuCode={"DEV0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='디바이스 관리'/>
                        <Card className="card shadow mb-4" style={{minHeight: "670px"}}>
                            <Card.Header className="py-3">
                                <div style={{display: "flex"}}>
                                    <div>
                                        <h6 className="m-0 font-weight-bold text-primary">{selectedValueTitle} 검색</h6>
                                        <p className="mb-2 mt-2 basic_font">{selectedValueContent} 기준으로 조회 합니다.</p>
                                    </div>
                                    <div className={writeAuthorityYn ? " active" : " inactive"} style={{marginLeft: "auto"}}>
                                        <Button onClick={handleClick}>시리얼 번호 발주</Button>
                                    </div>
                                </div>
                                {loading ? <Loading/> : null}
                                <Form id="searchForm">
                                    <div className="form-group row">
                                        <div className="search_area">
                                            <Form.Select className="select_box" id='search_select' value={selected}
                                                         onChange={handleChangeSelect}>
                                                <option value="1">시리얼번호</option>
                                                <option value="2">설명</option>
                                                <option value="3">릴리즈 번호</option>
                                                <option value="4">디바이스타입</option>
                                                <option value="5">생성일</option>
                                                <option className={nowCustomerCode === null ? " active" : " inactive"} value="6">고객사 코드</option>
                                            </Form.Select>
                                            <Form.Select className={"select_box customerCode " +customerSelectState} value={customerCodeSelected}
                                                         onChange={handleChangeCustomerCodeSelect} name="customerCode">
                                                {customerCode.map(customerCode => (
                                                    <option key={customerCode.customerCode}
                                                            value={customerCode.customerCode}>{customerCode.customerName}</option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control type="text" value={textData} id={customerCodeSelect} className={textState}
                                                      onChange={(e) => setTextData(e.target.value)}
                                                      onKeyDown={handleKeyDown} placeholder={selected === "6" ? "릴리즈 번호" : ""}/>
                                            <Form.Select className='select_box' id={deviceSelectState}
                                                     value={deviceSelected} onChange={handleChangeDeviceSelect}>
                                                {deviceType.map(deviceType => (
                                                <option key={deviceType.type}
                                                        value={deviceType.type}>{deviceType.description}</option>
                                                ))}
                                            </Form.Select>
                                            <Form id={calendarSelectState}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
                                                    <DemoContainer components={['DatePicker', 'DatePicker']} sx={{marginLeft:'1rem'}}>
                                                        <DatePicker
                                                            label="시작일자"
                                                            format="YYYY-MM-DD"
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={startDate}
                                                            onChange={handleStartDate}
                                                            defaultValue={dayjs().locale('ko')}
                                                            shouldDisableDate = {(day) => {
                                                                return day > endDate;
                                                            }}
                                                        />
                                                        <DatePicker
                                                            label="종료일자"
                                                            format="YYYY-MM-DD"
                                                            slotProps={{
                                                                textField:{
                                                                    size:'small'
                                                                }
                                                            }}
                                                            value={endDate}
                                                            onChange={handleEndDateChange}
                                                            slots={{ textField: TextField }}
                                                            disableFuture
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </Form>
                                        </div>
                                        <div className="search_button_area">
                                            <Button variant="primary" className="search_button"
                                                    onClick={handleSubmit}>검색</Button>
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <div style={{display: "flex", marginBottom: "5px"}}>
                                    <p className="card-body_content" style={{display:"flex", alignItems:"center", margin:"0 10px 0 0"}}>검색 결과 : 총 {totalData}건</p>
                                    <Form.Select className="select_box" id='search_select' value={listSelected}
                                                 onChange={handleChangeListSelect}>
                                        <option value="15">15개</option>
                                        <option value="30">30개</option>
                                        <option value="50">50개</option>
                                        <option value="100">100개</option>
                                    </Form.Select>
                                    <p className="card-body_content" style={{margin:"11px 0 0 30px"}}>사용중: {usingSerialCnt}건 미사용: {totalData - usingSerialCnt}건</p>
                                    <Button className={writeAuthorityYn ? " active" : " inactive"} variant="danger"
                                            onClick={handleDeleteUser}
                                            style={{marginLeft: "auto", backgroundColor: '#dc3545'}}>삭제</Button>
                                </div>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell className={writeAuthorityYn ? " active" : " inactive"}><input type={"checkbox"} checked={isCheckedAll}
                                                                  onChange={selectAll}/></StyledTableCell>
                                                <StyledTableCell align="center">시리얼번호</StyledTableCell>
                                                <StyledTableCell align="center">설명</StyledTableCell>
                                                <StyledTableCell align="center">사용 여부</StyledTableCell>
                                                <StyledTableCell align="center">릴리즈 번호</StyledTableCell>
                                                <StyledTableCell align="center">디바이스타입</StyledTableCell>
                                                <StyledTableCell align="center">고객사 코드</StyledTableCell>
                                                <StyledTableCell align="center">생성일</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map((data) => (
                                                <TableRow key={data.serialNumber}>
                                                    <StyledTableCell component="th" scope="row" className={writeAuthorityYn ? " active" : " inactive"}>
                                                        <input type={"checkbox"}
                                                               checked={checkedItems.includes(data.serialNumber)}
                                                               onChange={(e) => handleSingleCheckboxChange(e, data.serialNumber)}/>
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">{data.serialNumber || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.description || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.useYn ? 'O' : 'X'}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.releaseNo || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.deviceTypeDescription || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{customerFormat(data.customerCode)}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.registDtm || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                        <div>
                            <Pagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}>
                            </Pagination>
                            <div style={{display:"flex", justifyContent:"center", marginBottom:'1rem'}}>
                                <Form.Control className="currentForm" value={textCurrentPage} onChange={(e) => setTextCurrentPage(e.target.value)}/>
                                <button className="btn btn-primary currentButton" onClick={handleCurrentPageText}><span>이동</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )

}

export default DeviceManagement;